export enum DaysSchemasValidationError {
  NO_ELEVEN_HOURS_OF_BREAK,
  NO_THIRTY_FIFT_HOURS_BREAK_IN_WEEK,
  MAX_SIX_DAYS_IN_ROW_EXCEEDED,
  WORKING_DAY_LIMIT_EXCEEDED,
  NO_EVERY_FOURTH_SUNDAY_FREE,
  CALENDAR_LOCKED,
}
